var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { styledWithTheme } from '../../style/theme';
var Area = styledWithTheme.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transition: transform 0.2s, opacity 0.5s;\n  transform: ", ";\n  ", "\n"], ["\n  transition: transform 0.2s, opacity 0.5s;\n  transform: ", ";\n  ",
    "\n"])), function (p) { return (p.pushed ? 'scale(' + p.pushScale + ')' : 'scale(1)'); }, function (p) {
    return p.disabled
        ? "\n      pointer-events: none;\n      opacity: " + p.theme.opacities.disabled + ";\n      cursor: default;\n  "
        : "\n    :hover {\n      " + (p.hoverEffect ? "opacity: " + p.theme.opacities.hover + ";" : '') + "\n      cursor: pointer;\n    }\n    * {\n      :hover {\n        cursor: unset;\n      }\n    }\n  ";
});
var Pushable = /** @class */ (function (_super) {
    __extends(Pushable, _super);
    function Pushable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { pushed: false };
        return _this;
    }
    Pushable.prototype.render = function () {
        var _this = this;
        return (React.createElement(Area, __assign({}, this.props, { onMouseDown: function (e) {
                if (!_this.props.disabled) {
                    _this.setState({ pushed: true });
                    if (_this.props.onMouseDown) {
                        _this.props.onMouseDown(e);
                    }
                }
            }, onMouseUp: function (e) {
                if (!_this.props.disabled) {
                    _this.setState({ pushed: false });
                    if (_this.props.onMouseUp) {
                        _this.props.onMouseUp(e);
                    }
                }
            }, onMouseLeave: function (e) {
                if (!_this.props.disabled) {
                    _this.setState({ pushed: false });
                    if (_this.props.onMouseLeave) {
                        _this.props.onMouseLeave(e);
                    }
                }
            }, pushed: this.state.pushed && !this.props.disablePushEffect, pushScale: this.props.pushScale || 0.97, hoverEffect: !this.props.disableHoverEffect && !this.props.disabled, disabled: !!this.props.disabled }), this.props.children));
    };
    return Pushable;
}(React.Component));
export { Pushable };
var templateObject_1;
//# sourceMappingURL=pushable.js.map